module.exports = __webpack_public_path__ + "static/media/error-dark-circular.0c24acd3.png";